import { Beacon } from '@dicetechnology/dice-unity/lib/services/Beacon';
import {
    ENDEAVOR_AUTH,
    REACT_APP_ENDEAVOR_HEARTBEAT_URL,
    REACT_APP_ENDEAVOR_REALM,
    REACT_APP_ENDEAVOR_X_API_KEY
} from '../constants/api-constants';
import api from '../endeavor-api';
import { fetchToken, getToken } from './auth-service';
import { deleteFromSessionStorage, setSessionStorageItem } from '../../../utils';
import { hasValue, isNumber } from '../../../general-helpers';

const VOD_CONTENT_TYPE = 'VOD';

const UNAUTHORISED = 401;
const FORBIDDEN = 403;
const CONFLICT = 409;

export const isPlaybackBlockedError = (error) => hasValue(error) &&
    (error.status === FORBIDDEN || error.status === CONFLICT);

const buildHeartbeatError = (status) => Object.assign(
    new Error(`Endeavor heartbeat request failed with status ${status}`),
    { status }
);

const postHeartbeat = (url, payload, authToken) => api.post(url, payload, {
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${authToken}`,
        'x-api-key': REACT_APP_ENDEAVOR_X_API_KEY,
        Realm: REACT_APP_ENDEAVOR_REALM,
    },
});

const beaconHttp = {
    post: async (url, payload) => {
        try {
            let authToken = await getToken();
            let response;

            try {
                response = await postHeartbeat(url, payload, authToken);
            } catch (error) {
                if (!error.response || error.response.status !== UNAUTHORISED) {
                    throw error;
                }

                authToken = await fetchToken();
                deleteFromSessionStorage(ENDEAVOR_AUTH);
                setSessionStorageItem(ENDEAVOR_AUTH, authToken);
                response = await postHeartbeat(url, payload, authToken);
            }

            return {
                response: { ok: true, status: response.status },
                parsedData: response.data,
            };
        } catch (error) {
            throw buildHeartbeatError(error.response ? error.response.status : 0);
        }
    },
};

export const createVodHeartbeat = ({ videoId, onError = () => {} }) => {
    if (!isNumber(videoId) || !hasValue(REACT_APP_ENDEAVOR_HEARTBEAT_URL)) {
        return null;
    }

    const beacon = new Beacon({
        http: beaconHttp,
        url: REACT_APP_ENDEAVOR_HEARTBEAT_URL,
        onError,
    });

    beacon.video = {
        type: VOD_CONTENT_TYPE,
        id: Number(videoId),
    };

    return beacon;
};
